const EXTENSION_SEPARATOR = ".";

export const getFileExtension = (file: File): string => {
    const lastDotIndex = file.name.lastIndexOf(EXTENSION_SEPARATOR);

    return lastDotIndex > 0
        ? file.name.substring(lastDotIndex).toLowerCase()
        : "";
};
